<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-col class="pa-0">
        <SubscriptionRequiredDialog
            v-if="trial_ended_dialog.show"
            :show-dialog="trial_ended_dialog.show"
            :account="trial_ended_dialog.account"
            @close="trial_ended_dialog.show = false"
        ></SubscriptionRequiredDialog>
        <v-expand-transition

        >
            <Calendar
                v-show="isCalendarOpen"
                :is-visible="isCalendarOpen"
                class="dashboard-calendar global-elevation"
                :weeks="1"
                :unit="''"
                show-selection
            />
        </v-expand-transition>
        <div class="container">
            <v-row no-gutters>
                <v-col
                    :class="[
                        searchMode ? 'py-0 ' : 'pa-0',
                        searchMode && $vuetify.breakpoint.smAndDown
                            ? 'mx-2 test'
                            : '',
                        mobile_show_filterbar || $vuetify.breakpoint.mdAndUp
                            ? ''
                            : 'mt-3'
                    ]"
                >
                    <ModernFilterBar
                        v-if="data_loaded && (mobile_show_filterbar || $vuetify.breakpoint.mdAndUp)"
                        :show-filters="searchMode"
                        :filter-controller="filterController"
                    >
                        <template
                            v-slot:[dynamicFilterSlotName]="{ filters, filterAdd, filterRemove }"
                        >
                            <AddFilterButton
                                :filters="filters"
                                @add_filter="addingFilter($event, filterAdd)"
                            />
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <icon-button
                                        :on="on"
                                        icon="Delete"
                                        @click="filterController.resetFilters()"
                                    />
                                </template>
                                {{ $t("Clear filters") }}
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <icon-button
                                        :on="on"
                                        icon="Save"
                                        @click="onSaveFiltersClick"
                                    />
                                </template>
                                {{ $t("Save bookmark") }}
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <icon-button
                                        v-if="$vuetify.breakpoint.smAndDown"
                                        :on="on"
                                        @click="onSearchIconClick"
                                    >
                                        {{ searchMode ? "mdi-filter-remove" : "mdi-filter" }}
                                    </icon-button>
                                </template>
                                {{ searchMode ? $t("Remove filters") : $t("Filter") }}
                            </v-tooltip>
                            <DashboardDotMenu
                                v-if="$vuetify.breakpoint.smAndDown"
                                :group-by="urlAdapter.getUrlParameter('groupBy')"
                                :search-mode="searchMode"
                                :show-selection-checkbox="showSelectionCheckbox"
                                @select_grouping="urlAdapter.setUrlParameter('groupBy', $event)"
                                @reset_layout="filterController.resetFilters()"
                                @bulkSelection="showSelectionCheckbox = $event"
                            >
                                <ColumnController
                                    :headers="fieldColumns"
                                    :visible-headers="
                                        urlAdapter.getUrlParameter('columns')
                                    "
                                    @update_columns="
                                        urlAdapter.setUrlParameter('columns', $event)
                                    "
                                />
                            </DashboardDotMenu>
                        </template>
                    </ModernFilterBar>
                </v-col>
            </v-row>
            <v-row
                no-gutters
                justify="space-between"
                align="end"
                :class="{'align-center': !$vuetify.breakpoint.mdAndUp}"
            >
                <v-col class="shrink">
                    <v-row
                        class="flex-nowrap pl-1"
                        align="center"
                        no-gutters
                    >
                        <v-tooltip v-if="!showSelectionCheckbox" bottom>
                            <template v-slot:activator="{ on }">
                                <icon-button
                                    :on="on"
                                    icon="CheckCheck"
                                    @click="toggleBulkAction"
                                >
                                    done_all
                                </icon-button>
                            </template>
                            {{ $t("Show multiselect") }}
                        </v-tooltip>
                        <v-simple-checkbox
                            v-else
                            class="mr-2 ml-2 z-index-lvl-2"
                            :value="selectedListIds.value > 0"
                            color="primary"
                            @input="selectTasks"
                        />
                        <DropMenu
                            v-if="$vuetify.breakpoint.smAndDown"
                            :items="f_bookmarks('dashboard_search')"
                            name-key="name"
                            value-key="id"
                            icon=""
                            :menu-props="{
                                'open-on-hover': false,
                                'offset-y': true
                            }"
                            :custom-rules="activeBookmarkRule"
                            :hover-action="onDeleteBookmarkClick"
                            enable-hover-action
                            :show-selected-first="false"
                            @input="navigate_bookmark($event)"
                        >
                            <template v-slot="{ on }">
                                <v-btn
                                    text
                                    class="text-none px-3"
                                    style="letter-spacing: normal; z-index: 4; pointer-events: initial;"
                                    v-on="on"
                                >
                                    <div
                                        class="body-2 neutral_n300--text"
                                        style="flex-wrap: nowrap; white-space: nowrap"
                                    >
                                        {{
                                            f_bookmarks(
                                                "dashboard_search"
                                            ).find(i => activeBookmarkRule(i))
                                                ? f_bookmarks(
                                                    "dashboard_search"
                                                ).find(i => activeBookmarkRule(i))
                                                    .name
                                                : format_friendly_date_range(
                                                    new Date(selected_dates[0]),
                                                    new Date(selected_dates[1])
                                                )
                                        }}
                                    </div>
                                    <v-icon
                                        right
                                        color="grey"
                                    >
                                        mdi-menu-down
                                    </v-icon>
                                </v-btn>
                            </template>
                        </DropMenu>

                        <span
                            v-else-if="!searchMode"
                            class="body-2 shrink"
                            style="white-space: nowrap"
                        >
                            {{
                                format_friendly_date_range(
                                    new Date(selected_dates[0]),
                                    new Date(selected_dates[1])
                                )
                            }}
                        </span>
                    </v-row>
                </v-col>
                <v-col class="shrink z-index-lvl-2">
                    <v-row
                        v-if="$vuetify.breakpoint.mdAndUp"
                        class="flex-nowrap"
                        align="center"
                        no-gutters
                    >
                        <v-col class="shrink">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <icon-button
                                        :on="on"
                                        :is-active="searchMode"
                                        icon="SlidersHorizontal"
                                        @click="onSearchIconClick"
                                    />
                                </template>
                                {{ searchMode ? $t("Remove filters") : $t("Filter") }}
                            </v-tooltip>
                        </v-col>
                        <v-col class="shrink">
                            <DashboardDotMenu
                                :group-by="urlAdapter.getUrlParameter('groupBy')"
                                :search-mode="searchMode"
                                :show-selection-checkbox="showSelectionCheckbox"
                                @select_grouping="urlAdapter.setUrlParameter('groupBy', $event)"
                                @reset_layout="filterController.resetFilters()"
                                @bulkSelection="showSelectionCheckbox = $event"
                            >
                                <ColumnController
                                    :headers="fieldColumns"
                                    :visible-headers="urlAdapter.getUrlParameter('columns')"
                                    @update_columns="urlAdapter.setUrlParameter('columns', $event)"
                                />
                            </DashboardDotMenu>
                        </v-col>
                    </v-row>
                    <v-col v-else class="shrink">
                        <v-btn
                            small
                            text
                            class="text-none body-2 neutral_n300--text"
                            style="pointer-events: initial; height: auto;"
                            @click="onSearchIconClick()"
                        >
                            {{
                                searchMode ? $t("Hide filters") : $t("Show filters")
                            }}
                        </v-btn>
                    </v-col>
                </v-col>
            </v-row>
            <v-row v-if="!opening" no-gutters>
                <v-col :style="!isCalendarOpen ? 'position: relative' : ''">
                    <BulkActionBar
                        :items="filteredTasks"
                        :selected-list-ids="selectedListIds"
                        :is-mobile="$vuetify.breakpoint.smAndDown"
                        :relative-elem="taskListDashboard"
                    />
                    <TasksList
                        v-if="filteredTasks.length > 0 || searchMode"
                        ref="taskListDashboard"
                        :tasks="filteredTasks"
                        :group-by="urlAdapter.getUrlParameter('groupBy')"
                        :chip-columns="visible_headers"
                        :alway-open-grouping="searchMode"
                        :selected-date-range="selected_dates"
                        :is-mobile="$vuetify.breakpoint.smAndDown"
                        show-client-name
                    >
                        <template
                            v-slot:row="{
                                item,
                                chipColumns,
                                showClientName,
                                isMobile,
                                isFirst,
                                isLast
                            }"
                        >
                            <TaskListRow
                                :item="item"
                                :chip-columns="chipColumns"
                                :show-client="showClientName"
                                :is-mobile="isMobile"
                                :show-selection-checkbox="showSelectionCheckbox"
                                :color-ranges="colorRanges"
                                :style="[
                                    {
                                        'border-top-left-radius': isFirst
                                            ? '8px'
                                            : '',
                                        'border-top-right-radius': isFirst
                                            ? '8px'
                                            : '',
                                        'border-bottom-left-radius': isLast
                                            ? '8px'
                                            : '',
                                        'border-bottom-right-radius': isLast
                                            ? '8px'
                                            : ''
                                    }
                                ]"
                            />
                        </template>
                    </TasksList>
                    <div
                        v-else
                        :class="{
                            'px-3': $vuetify.breakpoint.smAndDown,
                            'my-10': !$vuetify.breakpoint.smAndDown
                        }"
                    >
                        <Sunshine/>
                    </div>
                    <v-row no-gutters>
                        <v-col class="text-center">
                            <v-btn
                                v-if="showMore"
                                text
                                color="primary"
                                class="mt-2 mb-5"
                                :loading="loadMoreLoading"
                                @click="onLoadMore"
                            >
                                {{ $t("Show more") }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-col>
</template>

<script>
import {
    computed,
    ref,
    watch,
    onUnmounted,
    onMounted, reactive
} from "@vue/composition-api";
import TasksList from "../Task/TasksList.vue";
import ColumnController from "../../components/ColumnController";
import DropMenu from "../../components/ModernFilterBar/components/DropMenu";
import TaskListRow from "../../views/Task/TaskListRow.vue";
import TaskModule from "../../store/modules/task";
import AccountModule from "../../store/modules/account";
import {useTopicStore} from "../../store/modules/topic";
import BookmarkModule from "../../store/modules/bookmark";
import ClientModule from "../../store/modules/client";
import DialogModule from "../../store/modules/dialog";
import {$t} from "@/i18n";
import DashboardDotMenu from "./DashboardDotMenu";
import CalendarEventModule from "../../store/modules/calendar_event";
import BookmarkMenu from "../../composables/use-bookmark-menu";
import AppModule from "../../store/modules/app";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import {
    calcDateEquals,
    formatDateShort,
    formatDateCustom,
    formatDate,
    parseSysDate, formatSysDate
} from "@/plugins/formatting";
import Sunshine from "../../components/Sunshine";
import SubscriptionRequiredDialog from "@/views/Subscription/SubscriptionRequiredDialog";
import RightsModule from "@/composables/use-rights";
import {debounce} from "throttle-debounce";
import AddFilterButton from "@/components/ModernFilterBar/components/AddFilterButton";
import {deepClone} from "@/helpers/helpers";
import BulkActionBar from "@/components/BulkActionBar/BulkActionBarDashBoard";
import {getColorRanges} from "../../composables/use-task-color";
import ModernFilterBar from "@/components/ModernFilterBar";
import UrlAdapter from "@/urlAdapter/urlAdapter";
import FilterBarController from "@/components/ModernFilterBar/FilterBarController";
import {Router} from "@/composables/Router";
import ProjectModule from '../../store/modules/project'
import Calendar from "@/views/Calendar/Calendar.vue";
import {useMemberStore} from "../../store/modules/member";

export default {
    name: "Dashboard",
    components: {
        Calendar,
        DropMenu,
        TasksList,
        ColumnController,
        DashboardDotMenu,
        TaskListRow,
        BulkActionBar,
        Sunshine,
        SubscriptionRequiredDialog,
        AddFilterButton,
        ModernFilterBar
    },

    setup(props, ctx) {
        const mobile_show_filterbar = ref(true);
        const topicStore = useTopicStore()
        const {
            navigate_bookmark,
            f_bookmarks,
            activeBookmarkRule,
            onDeleteBookmarkClick
        } = BookmarkMenu();
        const {fetchCalendarPeriod} = CalendarEventModule();
        const {
            openDialog,
            setDialogOptions,
        } = DialogModule();
        const data_loaded = ref(false);
        const { bookmarks } = BookmarkModule();
        const {
            fetchTasks,
            clearTasks,
            tasks_list,
            tasks_total,
            selected_date,
            selected_date_scope,
            clearAllSelectedListIds,
            selectedListIds,
            setSelectedListIds,
            projects
        } = TaskModule();
        const {fetchVisibleClients, clients} = ClientModule();
        const {
            available_accounts,
            current_account,
            accounts_info,
            isFeatureEnabledAnywhere,
            isFeatureEnabled
        } = AccountModule();
        const { projectsList, projectsFetched, fetchProjects, projectStatuses, setProjectsFetched, isEventTypeCompany } = ProjectModule();
        const memberStore = useMemberStore()
        const {can_edit_account} = RightsModule();
        const opening = ref(true);
        const loadMoreLoading = ref(false);
        const showMore = ref(false);
        const itemsPerPage = ref(50);
        const trial_ended_dialog = ref({show: false, account: null});
        const getSearchMode = function () {
            return urlAdapter.getUrlParameter('searchMode')
        };
        const curDate = ref(new Date())
        const showSelectionCheckbox = ref(false);
        const taskListDashboard = ref(null);
        const dateChangeInterval = ref(null);
        const router = Router();

        const visibleMembers = computed(() => {
            return memberStore.getAllMembers()
        })

        const urlAdapter = new UrlAdapter()
        urlAdapter.loadDefaultBookmark('dashboard_search', bookmarks.value)
        /** @type {FilterBarController} */
        const filterController = reactive(FilterBarController.init(urlAdapter))

        function toggleBulkAction() {
            clearAllSelectedListIds();
            showSelectionCheckbox.value = !showSelectionCheckbox.value;
        }

        function toggleSelectionCheckbox() {
            window.addEventListener("keydown", e => {
                if (navigator.userAgent.indexOf("Mac") !== -1) {
                    if (e.metaKey) {
                        toggleBulkAction();
                    }
                } else {
                    if (e.ctrlKey) {
                        toggleBulkAction();
                    }
                }
            });
        }

        const getDefaultDatesList = function (searchMode) {
            if (searchMode) {
                // do nothing
            }
            let default_dates_list = [
                new Date().formatSysDate(),
                new Date().formatSysDate(),
                "d_0",
                "d_0"
            ];
            return default_dates_list;
        };

        const debouncedBackendQuery = debounce(300, false, show_more => {
            backendQuery(show_more);
        });

        const usersWithoutGroups = computed(() => visibleMembers.value.filter(x => x.type === 'person'))
        const defaultDelegatedToItems = computed(() => visibleMembers.value.map(x => x.id).flat(1))

        const isProjectsFetching = ref(false)
        const getProjectsForFilters = () => {
            if(!isProjectsFetching.value && !projectsFetched.value) {
                isProjectsFetching.value = true
                fetchProjects({project_status: [projectStatuses.value.active, projectStatuses.value.cancelled]}).then((data) => setProjectsFetched(true, data.items)).catch(() => setProjectsFetched(false)).finally(() => isProjectsFetching.value = false)
            }
            return projectsList.value
        }

        const topics = computed(() => topicStore.getAllTopics())

        const filters = computed(() => [
            {
                key: "dates_list",
                default_value: getDefaultDatesList(getSearchMode()),
                default: true,
                extraItems: [
                    {title: $t("To do today"), start: "d_0", end: "d_0"},
                    {title: $t("This month"), start: "som_0", end: "eom_0"},
                    {title: $t("Last month"), start: "som_-1", end: "eom_-1"},
                    {title: $t("This and next month"), start: "som_0", end: "eom_1"},
                    {title: $t("Last 3 months"), start: "som_-3", end: "eom_-1"},
                    {title: $t("Next 3 months"), start: "som_1", end: "eom_3"}
                ]
            },
            {
                key: "task_status",
                default_value: ['todo'],
                default: true,
                items: [
                    {name: $t("Todo"), value: "todo"},
                    {name: $t("Overdue"), value: "overdue"},
                    {name: $t("Done"), value: "done"},
                    {name: $t("Delayed"), value: "delayed"},
                    {name: $t("Starts"), value: ""},
                ]
            },
            {key: "topic_id_list", default_value: [], default: true, items: topics},
            {key: "client_id_list", default_value: [], default: true, items: clients},
            {key: "person_id_list", default_value: [current_account.value.id], default: true, items: visibleMembers},
            {key: "keyword", default_value: [], default: true},
            {key: "account_id_list", default_value: [], items: available_accounts},
            {key: "is_important", default_value: ["1"]},
            {key: "is_extra", default_value: ["1"]},
            {key: "is_recurring", default_value: ["1"]},
            {key: "follow", default_value: ["1"]},
            {key: "is_commented", default_value: ["1"]},
            {key: "is_tracked_time", default_value: ["1"]},
            {key: "is_estimated", default_value: ["1"]},
            {key: "delegated_to", default_value: defaultDelegatedToItems.value, items: visibleMembers},
            { key: "delegated_by", default_value: [current_account.value.id], items: usersWithoutGroups },
            { key: "is_cp", default_value: ["1"], feature: 'client_portal'},
            {key: "project_id_list", default_value: [], feature: 'project', items: getProjectsForFilters, loading: () => isProjectsFetching.value}
        ].filter(x => x.feature === undefined || isFeatureEnabledAnywhere(x.feature))
        )

        urlAdapter.addGetStateCallback(() => {
            return {
                "sortBy": urlAdapter.getUrlParameter('sortBy') ? urlAdapter.getUrlParameter('sortBy') : "",
                "sortDesc": urlAdapter.getUrlParameter('sortDesc') ? urlAdapter.getUrlParameter('sortDesc') : false,
                "itemsPerPage": urlAdapter.getUrlParameter('itemsPerPage') ? urlAdapter.getUrlParameter('itemsPerPage') : 50,
                "page": urlAdapter.getUrlParameter('page') ? urlAdapter.getUrlParameter('page') : 1,
                "columns": urlAdapter.getUrlParameter('columns') ? urlAdapter.getUrlParameter('columns') : isFeatureEnabledAnywhere("project") ? ["project", "depends_on", "topic", "comments", "client_portal"] : ["project", "topic", "depends_on", "comments", "client_portal"],
                "groupBy": urlAdapter.getUrlParameter('groupBy') ? urlAdapter.getUrlParameter('groupBy') : '',
                "groupDesc": urlAdapter.getUrlParameter('groupDesc') ? urlAdapter.getUrlParameter('groupDesc') : '',
                "searchMode": urlAdapter.getUrlParameter('searchMode') ? urlAdapter.getUrlParameter('searchMode') : false
            }
        })

        filterController.setOnRemoveFunc((filterKey) => {
            if (filterKey === 'follow') {
                filterController.resetFiltersNoPersist("person_id_list");
            } else if (filterKey === 'delegated_by' && !filterController.queryParameters()['delegated_to']) {
                filterController.resetFiltersNoPersist("person_id_list");
            } else if (filterKey === 'delegated_to' && !filterController.queryParameters()['delegated_by']) {
                filterController.resetFiltersNoPersist("person_id_list");
            }
        })

        const searchMode = computed(() => {
            return !!urlAdapter.getUrlParameter("searchMode");
        });

        onMounted(() => {
            toggleSelectionCheckbox();
            checkTrialIsEnded();
        });

        const has_event_type_company = computed(() => {
            return !!available_accounts.value.find(
                (account) => isEventTypeCompany(account.id)
            );
        })

        const columns = ref([
            {text: has_event_type_company.value ? $t('Event') : $t("Project"), value: "project", align: "", class: "text-no-wrap"},
            {text: $t("Depends on"), value: "depends_on", align: "", class: "text-no-wrap"},
            {text: $t("Topic"), value: "topic", align: "", class: "text-no-wrap"},
            { text: $t("Client portal"), value: "client_portal", class: "text-no-wrap", align: "" },
            {text: $t("Checklist"), value: "checklist", class: "text-no-wrap", align: ""}
        ]);

        const appModule = AppModule();
        let promise_list = [];
        const custom_fields = computed(function () {
            return appModule.custom_fields.value;
        });
        const classifiers_loaded = ref(false);
        if (!classifiers_loaded.value) {
            let types = ["custom_fields"];
            if (isFeatureEnabledAnywhere("project"))
                types.push("progress_steps");

            appModule.fetchClassifiers({types})
                .then(() => {
                    classifiers_loaded.value = true;
                })
                .catch(ex => errorDialog.showError(ex));
        }
        const initialize = async () => {
            promise_list.push(fetchVisibleClients());
            await Promise.all(promise_list);
            data_loaded.value = true;

            filterController.initFilters(filters.value)
            filterController.startUrlWatcher()
        };
        initialize();

        watch (selected_date, val => {
            if (ctx.root.$vuetify.breakpoint.smAndDown) {
                let payload = {
                    meta_filter: 'calendar',
                    dates_list: [val, val].join(","),
                    date_from: val,
                    date_until: val,
                    page: 1,
                    itemsPerPage: 500,
                    // TODO: @jaanus
                    // filterHelper is not defined, commented it out for now but should look at it
                    //...filterHelper.getOnlyRelevantQueryParams()
                }
                fetchCalendarPeriod(payload);
            }
            if (!searchMode.value) {
                if (selected_date_scope.value === "week") {
                    let date1 = parseSysDate(val).calcWeekStart().formatSysDate();
                    let date2 = parseSysDate(val).calcWeekEnd().formatSysDate();
                    urlAdapter.setUrlParameter("dates_list", [date1, date2]);
                } else {
                    urlAdapter.setUrlParameter("dates_list", [val, val]);
                }
            }
        }, { immediate: true });
        const fieldColumns = computed(() => {
            let c_fields = [];
            let unique_c_fields = [];
            for (const i in custom_fields.value) {
                for (const j in custom_fields.value[i]) {
                    const custom_field = custom_fields.value[i][j];
                    if (custom_field.related_type === 'task') {
                        c_fields.push({
                            text: custom_field.title,
                            value: custom_field.name,
                            class: ""
                        });
                    }
                }
            }

            c_fields.map(f => {
                if (!unique_c_fields.find(uf => uf.value === f.value)) {
                    unique_c_fields.push(f);
                }
            });

            return [...columns.value, ...unique_c_fields];
        });

        const visible_headers = computed(() => {
            let filtered = fieldColumns.value.filter(x =>
                urlAdapter.getUrlParameter("columns").includes(x.value)
            )

            return filtered
        });
        const colorRanges = computed(() => {
            if (!classifiers_loaded.value)
                return {};
            let ret = {};
            for (let project of projects.value) {
                if (!isFeatureEnabled(project.account_id, "project", false)) continue;
                if (appModule.progress_steps.value[project.account_id] === undefined) continue;
                if (appModule.custom_fields.value[project.account_id] === undefined) continue;
                ret[project.id] = getColorRanges(
                    appModule.progress_steps.value[project.account_id], project, appModule.custom_fields.value[project.account_id]
                );
            }
            return ret;
        });

        const applyDashboardFilterLogic = function (load_more, filters = null) {
            // make a copy of queryparameters, otherwise changes trigger new query
            if (!filters) {
                filters = urlAdapter.getUrlParameters();
            }

            // backend does more logic based on this..
            filters.meta_filter = filters.searchMode
                ? "dashboard_search"
                : "dashboard";
            // if not in search mode show only my tasks
            if (!filters.searchMode) {
                filters.person_id_list = [current_account.value.id];
            }

            // if filters change, limit should reset to 50
            if (load_more) {
                itemsPerPage.value += 50;
            } else {
                itemsPerPage.value = 50;
            }
            // raise itemsPerPage if query is grouped, otherwise too few rows
            filters.page = 1;
            filters.itemsPerPage = filters.groupBy ? 500 : itemsPerPage.value;
            return filters;
        };

        const backendQuery = function (load_more, filters = null) {
            filters = applyDashboardFilterLogic(load_more, filters);
            fetchTasks(filters)
                .then(function () {
                    opening.value = false;
                    loadMoreLoading.value = false;
                    showMore.value = tasks_list.value.length < tasks_total.value;
                })
                .catch(ex => errorDialog.showError(ex));
        };
        urlAdapter.setOnUrlChange((filters) => {
            backendQuery(false, filters)
            clearAllSelectedListIds();
            showSelectionCheckbox.value = false;

            if (
                !searchMode.value &&
                current_account.value &&
                current_account.value.id
            ) {
                setDefaultView(filters);
            }
        })

        const setDefaultView = function (filters) {
            filters = {...filters}

            filters["meta_filter"] = "dashboard"
            filters["searchMode"] = false

            let currentSaveAsDefault = {}

            try {
                let localStorageBookmarks = localStorage.getItem('autoSavedBookmarks')
                if (localStorageBookmarks) {
                    currentSaveAsDefault = JSON.parse(localStorageBookmarks)
                }
            } catch (e) {
                // Pass
            }

            currentSaveAsDefault['dashboard_search'] = filters
            localStorage.setItem('autoSavedBookmarks', JSON.stringify(currentSaveAsDefault))
        };

        const onLoadMore = () => {
            // Should make a request with same params, but more itemsPerPage
            loadMoreLoading.value = true;
            debouncedBackendQuery(true);
        };

        const selected_dates = computed(() => {
            // Used for grouping by date in TasksList
            // If not in search view, the small calendar should also control this
            return urlAdapter.getUrlParameter("dates_list");
        });

        const onSaveFiltersClick = () => {
            setDialogOptions({
                component: () => import("@/views/Dialog/BookmarkDialog"),
                payload: {
                    type: "dashboard_search",
                    canSaveAsDefault: true
                }
            });
            openDialog();
        };

        const onSearchIconClick = () => {
            filterController.resetFiltersNoPersist()

            let groupBy = urlAdapter.getUrlParameter("groupBy")
            // Reset groupBy filter if date or topic and exiting search mode. might be a better way to do this
            if (getSearchMode() && ['date', 'topic'].includes(groupBy)) {
                groupBy = ''
            }

            urlAdapter.setUrlParametersFromObject({
                "searchMode": !getSearchMode(),
                "dates_list": getDefaultDatesList(searchMode.value),
                "groupBy": groupBy,
                ...filterController.getCurrentFilterValues()
            })
        }
        const checkTrialIsEnded = () => {
            // mobile
            if (ctx.root.$vuetify.breakpoint.xsOnly) return;

            // mini uku
            if (ctx.root._route.query.ukuwinversion !== undefined) return;

            for (let i = 0; i < accounts_info.value.length; i++) {
                let company = accounts_info.value[i];
                if (company.type !== "company") continue;
                if (company.is_demo) continue;
                if (company.data && company.data.is_demo) continue; // legacy fallback

                if (company.bundles.length === 0) {
                    if (can_edit_account(company.id)) {
                        // alert admins
                        trial_ended_dialog.value.account = company;
                        trial_ended_dialog.value.show = true;
                        break;
                    }
                }
            }
        };

        const format_friendly_date_range = (
            date1,
            date2,
            prefix = $t("To do")
        ) => {
            let today = new Date();
            if (calcDateEquals(date1, date2, "day")) {
                if (calcDateEquals(today, date1, "day")) {
                    return prefix + " " + $t("today");
                } else if (calcDateEquals(today.calcAddDays(1), date1, "day")) {
                    return prefix + " " + $t("tomorrow");
                } else if (
                    calcDateEquals(today.calcAddDays(-1), date1, "day")
                ) {
                    return prefix + " " + $t("yesterday");
                } else {
                    return prefix + " " + formatDateShort(date1);
                }
            } else if (
                calcDateEquals(today.calcWeekStart(), date1, "day") &&
                calcDateEquals(today.calcWeekEnd(), date2, "day")
            ) {
                return $t("This week");
            } else if (
                calcDateEquals(
                    today.calcAddDays(7).calcWeekStart(),
                    date1,
                    "day"
                ) &&
                calcDateEquals(today.calcAddDays(7).calcWeekEnd(), date2, "day")
            ) {
                return $t("Next week");
            } else if (
                calcDateEquals(
                    today.calcAddDays(-7).calcWeekStart(),
                    date1,
                    "day"
                ) &&
                calcDateEquals(
                    today.calcAddDays(-7).calcWeekEnd(),
                    date2,
                    "day"
                )
            ) {
                return $t("Previous week");
            } else if (calcDateEquals(date1, date2, "month")) {
                return "{0} - {1}".format(
                    formatDateCustom(date1, "dd"),
                    formatDateShort(date2)
                );
            } else if (calcDateEquals(date1, date2, "year")) {
                return "{0} - {1}".format(
                    formatDateShort(date1),
                    formatDateShort(date2)
                );
            } else {
                return "{0} - {1}".format(formatDate(date1), formatDate(date2));
            }
        };

        onUnmounted(function () {
            clearTasks();
            clearAllSelectedListIds()
        });

        const dynamicFilterSlotName = computed(() => {
            return ctx.root.$vuetify.breakpoint.smAndDown ? "above" : "right";
        });

        const selectTasks = () => {
            tasks_list.value.forEach(task => {
                // jaanus bulk actions
                let id = task.id || task.virtual_id
                // console.log('select task', id)
                setSelectedListIds(id);
            });
        };

        const addingFilter = (ev, callback) => {
            if (ev.key === "follow") {
                filterController.addFilterNoPersist('follow')
                filterController.setValue('person_id_list', [])
                return;
            } else if (ev.key === "delegated_by") {
                filterController.addFilterNoPersist('delegated_by')
                filterController.setValue('person_id_list', [])
                return;
            } else if (ev.key === "delegated_to") {
                filterController.addFilterNoPersist('delegated_to')
                filterController.setValue('person_id_list', [])
                return;
            }

            callback(ev);
        };

        const doesTaskListContainOnlyFinishedTasks = (tasks) => {
            if (!tasks || !tasks.length) {
                return true
            }

            return !tasks.find(x => x.status !== 'finished')
        }

        const filteredTasks = computed(() => {
            return tasks_list.value.filter(task =>
                doesTaskListContainOnlyFinishedTasks(task.depends_on_items)
            )
        })

        // In case the current day changes and client is in default dashboard view then update tasks
        onMounted(() => {
            dateChangeInterval.value = setInterval(() => {
                if (searchMode.value) {
                    return
                }

                if (formatSysDate(new Date()) === formatSysDate(curDate.value)) {
                    return
                }

                curDate.value = new Date()
                debouncedBackendQuery()
            }, 60000)
        })

        onUnmounted(() => {
            clearInterval(dateChangeInterval.value)
        })

        return {
            format_friendly_date_range,
            selected_dates,
            data_loaded,
            tasks: tasks_list,
            filteredTasks,
            tasks_total: tasks_total,
            showMore,
            columns,
            fieldColumns,
            visible_headers,
            current_account,
            mobile_show_filterbar,
            opening,
            loadMoreLoading,
            trial_ended_dialog,
            colorRanges,
            navigate_bookmark,
            f_bookmarks,
            activeBookmarkRule,
            onDeleteBookmarkClick,
            onSaveFiltersClick,
            onSearchIconClick,
            onLoadMore,
            debouncedBackendQuery,
            searchMode,
            dynamicFilterSlotName,
            getDefaultDatesList,
            showSelectionCheckbox,
            selectedListIds,
            selectTasks,
            toggleBulkAction,
            addingFilter,
            taskListDashboard,
            isCalendarOpen: appModule.isCalendarOpen,
            /** @type {FilterBarController} */
            filterController,
            urlAdapter
        };
    }
};
</script>
<style scoped>
.z-index-lvl-2 {
    z-index: 2;
}

.dashboard-calendar {
    position: sticky;
    z-index: 3;
    top: 56px;
    border-radius: 0 0 0 8px;
    overflow: hidden;
}

</style>
